export const parseAffiliateLinkId = (url: string): number | null => {
  try {
    const urlObj = new URL(url)
    if (
      !urlObj.hostname.endsWith('.mpic.link') &&
      !urlObj.hostname.endsWith('.mtpc.se') &&
      !urlObj.hostname.endsWith('.mtpc.dev')
    ) {
      return null
    }
    const pathSegments = urlObj.pathname.split('/').filter(Boolean)
    if (pathSegments.length === 0) {
      return null
    }
    const firstSegment = pathSegments[0]!
    const id = parseInt(firstSegment, 10)
    return isNaN(id) ? null : id
  } catch {
    return null
  }
}

const affiliateLinkIdPattern = /^\d+$/

export const resolveAffiliateLinkId = (value: string | undefined): string | null | undefined => {
  const trimmedValue = value?.trim()
  if (!trimmedValue) {
    return undefined
  }

  if (affiliateLinkIdPattern.test(trimmedValue)) {
    return trimmedValue
  }

  const parsedAffiliateLinkId = parseAffiliateLinkId(trimmedValue)

  return parsedAffiliateLinkId === null ? null : String(parsedAffiliateLinkId)
}
